<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('glossary')"
                        :isNewButton="checkPermission('department_store')"
                        :isColumns="true"
                        @new-button-click="createFormShow()"
                        @filter-div-status="datatable.filterStatus=$event"
                >
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('glossary')"
                              :isNewButton="checkPermission('department_store')"
                              :isColumns="true"
                              @new-button-click="createFormShow()"
                              @filter-div-status="datatable.filterStatus=$event"
                >
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </HeaderMobile>
            </template>
            <datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear"
                              :export-excel="false">
                <b-row>
                    <b-col sm="6" md="4" lg="3" xl="6">
                        <b-form-group :label="$t('term')">
                            <b-form-input v-model="datatable.queryParams.filter.term">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4" lg="3" xl="6">
                        <b-form-group :label="$t('definition')">
                            <b-form-input v-model="datatable.queryParams.filter.definition">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4" lg="3" xl="6">
                        <b-form-group :label="$t('reference')">
                            <b-form-input v-model="datatable.queryParams.filter.reference">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>
            <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            >
            </datatable>

            <CommonModal ref="formModal"  :onHideOnlyX="true" @bHideModalHeaderClose="formClear()">
                <template v-slot:CommonModalTitle>
                    <span v-if="formProcess=='create'">{{ $t('new').toUpper() }}</span>
                    <span v-if="formProcess=='update'">{{ $t('update').toUpper() }}</span>
                </template>
                <template v-slot:CommonModalContent>
                    <create-form @createFormSuccess="createFormSuccess"
                                 v-if="formProcess=='create' && checkPermission('glossary_store')"
                    />
                    <update-form :formId="formId"
                                 @updateFormSuccess="updateFormSuccess"
                                 v-if="formProcess=='update' && checkPermission('glossary_update')"
                    />
                    <show-form :formId="formId"
                               v-if="formProcess=='show' && checkPermission('glossary_show')"
                    />
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from '@/layouts/AppLayout.vue'
import Header from '@/layouts/AppLayout/Header.vue'
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile.vue'

// Components
import DatatableFilter from '@/components/datatable/DatatableFilter.vue';
import Datatable from '@/components/datatable/Datatable.vue';
import CommonModal from '@/components/elements/CommonModal.vue';
import FacultySelectbox from '@/components/interactive-fields/FacultySelectbox.vue';
import ActiveOrPassive from '@/components/interactive-fields/TrueFalseSelectbox.vue'

// Pages
import CreateForm from './CreateForm.vue';
import UpdateForm from './UpdateForm.vue';
import ShowForm from "./ShowForm.vue"

// Services
// Others
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import qs from 'qs'
import GlossaryServices from "@/services/GlossaryServices";

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        DatatableFilter,
        Datatable,
        CommonModal,
        FacultySelectbox,
        CreateForm,
        UpdateForm,
        ShowForm,
        ValidationProvider,
        ValidationObserver,
        ActiveOrPassive
    },
    metaInfo() {
        return {
            title: this.$t('glossary')
        }
    },
    data() {
        return {
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: '',
                        field: 'buttons',
                        html: true,
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [
                            {
                                text: this.$t('show'),
                                class: 'ri-search-eye-line',
                                permission: 'glossary_show',
                                callback: (row) => {
                                    this.showForm(row.id);
                                }
                            },
                            {
                                text: this.$t('edit'),
                                permission: 'glossary_update',
                                class: 'ri-edit-box-line align-middle top-minus-1 mr-3 text-muted',
                                callback: (row) => {
                                    this.updateFormShow(row.id)
                                }
                            },
                            {
                                text: this.$t('delete'),
                                permission: 'glossary_delete',
                                class: 'ri-delete-bin-7-line align-middle top-minus-1 mr-3 text-muted',
                                callback: (row) => {
                                    this.formDelete(row.id)
                                }
                            },
                            {
                                text: this.$t('download'),
                                permission: "glossary_download",
                                class: 'ri-file-download-line align-middle top-minus-1 mr-3 text-muted',
                                callback: (row) => {
                                    this.fileDownload(row.file.uuid,row.file.file_name)
                                },
                                show:(row)=>{
                                    return !!row.file
                               }
                            }
                        ]
                    },
                    {
                        label: this.toUpperCase('term'),
                        field: 'term',
                        hidden: false
                    },
                    {
                        label: this.toUpperCase('definition'),
                        field: 'definition',
                        hidden: false
                    },
                    {
                        label: this.toUpperCase('reference'),
                        field: 'reference',
                        hidden: false
                    },
                    {
                        label: this.toUpperCase('file'),
                        field: 'file.file_name',
                        hidden: false
                    },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: 'id',
                    page: 1,
                    limit: 20
                }
            },
            formProcess: null,
            formId: null,
            form: {}
        }
    },
    created() {
        this.filterSet();
        this.formClear();
    },
    methods: {
        filterSet() {
            this.datatable.queryParams.filter = {
            }
        },
        filterClear() {
            this.filterSet()
            this.getRows();
        },
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        changeColumn(key) {
            this.datatable.columns[key].hidden = this.datatable.columns[key].hidden == true ? false : true;
        },
        onSortChange(params) {
            const sortType = params[0].type == 'desc' ? '-' : '';
            this.datatable.queryParams.sort = sortType + params[0].field
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };

            return GlossaryServices.getAll(config)
                .then((response) => {
                    this.datatable.rows = response.data.data
                    this.datatable.total = response.data.pagination.total
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },

        // Clear
        formClear() {
            this.formId = null
            this.formProcess = null
        },

        // Show
        showForm(id) {
            this.formId = id
            this.formProcess = 'show'
            this.$refs.formModal.$refs.commonModal.show()
        },

        // Create
        createFormShow() {
            this.formId = null
            this.formProcess = 'create'
            this.$refs.formModal.$refs.commonModal.show()
        },
        createFormSuccess() {
            this.$refs.formModal.$refs.commonModal.hide()
            this.getRows()
            this.formClear()
        },

        // Update
        updateFormShow(id) {
            this.formId = id
            this.formProcess = 'update'
            this.$refs.formModal.$refs.commonModal.show()
        },
        updateFormSuccess() {
            this.$refs.formModal.$refs.commonModal.hide()
            this.getRows()
            this.formClear()
        },

        // Delete
        formDelete(id) {
            this.$swal
                .fire({
                    text: this.$t('are_you_sure_to_delete'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no')
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        GlossaryServices.del(id)
                            .then(response => {
                                this.$toast.success(this.$t('api.' + response.data.message));
                                this.getRows();
                                this.formClear();
                            })
                            .catch(e => {
                                this.showErrors(e)
                            });
                    }
                })
        },
        fileDownload(uuid,name){
            GlossaryServices.fileDownload(uuid)
                .then(response => {
                    this._downloadFile(response,name)
                }).catch(error=>{
                    this.showErrors(error)
            })


        }
        // downloadExcel() {
        //     const config = {
        //         params: {
        //             ...this.datatable.queryParams
        //         },
        //         paramsSerializer: (params) => qs.stringify(params, {encode: false})
        //     };
        //
        //     DepartmentService.downloadAsExcel(config)
        //         .then(res => this._downloadFile(res, this.$t('departments') + '.xlsx'))
        //         .catch(err => this.showErrors(err))
        // }
    }
}
</script>

